import React from 'react';
import { identity } from 'ramda';

const branch =
  (test, left, right = identity) =>
  BaseComponent =>
  props => {
    const Left = left(BaseComponent);
    const Right = right(BaseComponent);

    return test(props) ? <Left {...props} /> : <Right {...props} />;
  };

export default branch;
